import {
  DISPLAY_DIVISION_IN_FORM_FOR_TOURNAMENT,
  SET_EVENT_SELECTED_FOR_TOURNAMENT,
  SET_VIRTUAL_EVENT_SELECTED_FOR_TOURNAMENT,
  DISPLAY_NEW_DIVISION_FOR_TOURNAMENT,
  CANCEL_DIVISION_FORM_FOR_TOURNAMENT,
  HIGHTLIGHT_SELECTED_EVENT_FOR_TOURNAMENT_DIVISIONS,
  HIGHLIGHT_SELECTED_VIRTUAL_EVENT_FOR_TOURNAMENT_DIVISIONS,
  DISPLAY_EVENTS_FOR_TOURNAMENT_DIVISIONS,
  DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_DIVISIONS,
  DISPLAY_DIVISION_FOR_TOURNAMENT_EVENT,
  SET_DIVISION_DISPLAY_DEFAULT
} from './constants';

export const displayDivisionInForm = divisionId => ({
  type: DISPLAY_DIVISION_IN_FORM_FOR_TOURNAMENT,
  payload: divisionId
});

export const setEventSelectedInState = eventId => ({
  type: SET_EVENT_SELECTED_FOR_TOURNAMENT,
  payload: eventId
});

export const setVirtualEventSelectedInState = virtualEventId => ({
  type: SET_VIRTUAL_EVENT_SELECTED_FOR_TOURNAMENT,
  payload: virtualEventId
});

export const displayNewDivision = () => ({
  type: DISPLAY_NEW_DIVISION_FOR_TOURNAMENT
});

export const cancelDivisionItemForm = () => ({
  type: CANCEL_DIVISION_FORM_FOR_TOURNAMENT
});

export const hightlightSelectedEvent = eventId => ({
  type: HIGHTLIGHT_SELECTED_EVENT_FOR_TOURNAMENT_DIVISIONS,
  payload: eventId
});

export const highlightSelectedVirtualEvent = virtualEventId => ({
  type: HIGHLIGHT_SELECTED_VIRTUAL_EVENT_FOR_TOURNAMENT_DIVISIONS,
  payload: virtualEventId
});

export const displayEvents = data => ({
  type: DISPLAY_EVENTS_FOR_TOURNAMENT_DIVISIONS,
  payload: data
});

export const displayVirtualEvents = virtualEvents => ({
  type: DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_DIVISIONS,
  payload: virtualEvents
});

export const displayDivisions = data => ({
  type: DISPLAY_DIVISION_FOR_TOURNAMENT_EVENT,
  payload: data
});

export const setDivisionDisplayDefault = data => ({
  type: SET_DIVISION_DISPLAY_DEFAULT,
  payload: data
});


// WEBPACK FOOTER //
// ./src/features/tournament/divisions/actionTypes.js